/****************************************************
 * 页面视图身份：动物详情标签属于同一查看会话，其余路由变化保持独立。
 * @author Francis
 * @since 2026-10-13
 **************************************************/

function stableValue(value) {
  if (Array.isArray(value)) return value.map(stableValue)
  if (value && typeof value === 'object') {
    return Object.fromEntries(Object.keys(value).sort().map((key) => [key, stableValue(value[key])]))
  }
  return value
}

/** 返回不可随路由对象原地变化的身份快照，仅动物详情忽略展示标签。 */
export function resolvePageViewIdentity(route = {}) {
  const query = { ...(route.query || {}) }
  const animalId = Array.isArray(query.animalId) ? query.animalId[0] : query.animalId
  const isAnimalProfile = String(route.path || '').toLowerCase() === '/anml/animal'
    && query.mode === 'profile' && Boolean(String(animalId || '').trim())
  const profileTab = JSON.stringify(query.profileTab) ?? ''
  if (isAnimalProfile) delete query.profileTab
  const contextKey = JSON.stringify(stableValue({
    path: route.path || '', name: String(route.name || ''), query,
    params: route.params || {}, hash: route.hash || '', meta: route.meta || {},
  }))
  return {
    isAnimalProfile,
    renderKey: isAnimalProfile ? contextKey : route.fullPath || route.path || '',
    contextKey,
    profileTab,
  }
}

/** 真正的动物、资源、其它参数或路由元数据变化不属于标签切换。 */
export function isAnimalProfileTabOnlyChange(previous, next) {
  return Boolean(previous?.isAnimalProfile && next?.isAnimalProfile
    && previous.contextKey === next.contextKey && previous.profileTab !== next.profileTab)
}
